import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-064b4665"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "row gx-4 gy-0"
}
const _hoisted_2 = { class: "col-12 col-md-6" }
const _hoisted_3 = { class: "col-12 col-md-6" }

import FontAwesomeListElement from '@/components/FontAwesomeList/FontAwesomeListElement.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FontAwesomeList',
  props: {
  icon: {
    type: String,
    default: () => 'fa-regular fa-chevron-right',
  },
  items: Array,
  multiColumn: Boolean,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (!__props.multiColumn)
    ? (_openBlock(), _createBlock(FontAwesomeListElement, {
        key: 0,
        items: __props.items
      }, null, 8, ["items"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(FontAwesomeListElement, {
            items: __props.items.filter((item, inx) => inx % 2 === 0 && item)
          }, null, 8, ["items"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(FontAwesomeListElement, {
            items: __props.items.filter((item, inx) => inx % 2 !== 0 && item)
          }, null, 8, ["items"])
        ])
      ]))
}
}

})